import React, { createContext } from 'react'
import store from '../stores/Store'

export const MobXContext = createContext()

// MobXContext.displayName = 'MobXCTX'

export const MobXProvider = ({ children }) => {
  return <MobXContext.Provider value={store}>{children}</MobXContext.Provider>
}
